//@flow
import { useViewport } from 'components/templates/viewportProvider';
import React, { useEffect, useState } from 'react';
import { StringUtil } from 'utils/StringUtil';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { CallToAction } from 'components/atoms/callToAction';
import './style.scss';
import Dotdotdot from 'react-dotdotdot';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { ApplyForJobButton } from 'components/organisms/applyForJobButton';
import { HTMLView } from 'components/atoms/htmlView';

type Props = {
  our_difference_description: string,
  our_difference_heading: string,
  infoLinks: Array<infoLinksProps>,
};

type dataProps = {
  id: number,
  tag_word: string,
  image: Array,
  mobile_image: Array,
  page_title: string,
  parent_page_title: string,
  short_content: Object,
  long_content: Object,
  long_mobile_content: Object,
  cms_page_id: number,
  path: string,
  web: string,
  mobile: string,
};

type infoLinksProps = {
  data: Array<dataProps>,
  title: string,
  link: string,
  id: number,
};

const CultureLeadershipMobileView = (props: Props) => {
  const { height } = useViewport();
  const {
    our_difference_description,
    our_difference_heading,
    infoLinks,
    cmsDetailsData,
    breadcrumbList,
  } = props;

  const [selected_link_id, set_selected_link_id] = useState(0);
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});
  const [show_overlay_button, set_show_overlay_button] = useState(false);

  useEffect(() => {
    if (cmsDetailsData) {
      checkOverlayCorrespondingFeature(selected_link_id);
    }
  }, [selected_link_id]);

  let long_content = infoLinks[selected_link_id].data.long_mobile_content;

  const checkOverlayCorrespondingFeature = selected_id => {
    let data = {};
    set_overlay_page_data(data);
    set_show_overlay_button(false);
    Object.values(cmsDetailsData).map((data, idx) => {
      if (infoLinks[selected_id].cms_page_id === data.cms_page_id) {
        set_overlay_page_data(data);
        set_show_overlay_button(true);
        return;
      }
    });
  };

  const handleFeatureSelected = id => {
    set_selected_link_id(id);
  };

  const calcHeight = () => {
    let section_doc = document.getElementsByClassName(
      'cultureLeadership-mobile-body'
    )[0];
    let inner_section_height =
      section_doc &&
      section_doc.getElementsByClassName('inner-section')[0].offsetHeight;
    let heading_height =
      section_doc &&
      section_doc.getElementsByClassName('heading-section')[0].offsetHeight;
    let carousal_height =
      section_doc &&
      section_doc.getElementsByClassName('horizontal-carousel-container')[0]
        .offsetHeight;
    let explore_button_doc =
      section_doc && section_doc.getElementsByClassName('explore')[0];
    let explore_button_height =
      section_doc && explore_button_doc ? explore_button_doc.offsetHeight : 0;
    let pararaph_height =
      inner_section_height -
      (heading_height + carousal_height + explore_button_height + 60);
    let pixel_height = pararaph_height + `px`;
    return pixel_height;
  };

  const renderOverlayButton = (
    <div className={'explore'}>
      <CallToAction
        text={'READ MORE'}
        mode={'transparent'}
        type={'link'}
        onClick={e => setshowDescriptionLayout(true)}
        size={'small'}
        isMobile="true"
      />
    </div>
  );

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'ourDifference'}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className="cultureLeadership-mobile-body" style={{ height }}>
      <div className="inner-section">
        <div className={'heading-section'}>
          <h2 className="heading">{our_difference_heading}</h2>
          <HTMLView
            className={'heading-description'}
            html={our_difference_description}
            tagName={'h4'}
          />
        </div>
        <HorizontalCarousel
          cssFor={'horizontal-carousel-container'}
          featureSelected={id => {
            handleFeatureSelected(id);
          }}
          selectedLinkId={selected_link_id}
          type={'text-carousal'}
          data={infoLinks}
        />
        <div className="feature-content">
          <h3>{infoLinks[selected_link_id].data.page_title}</h3>
          {infoLinks[selected_link_id].data.tag_word && (
            <span className="feature-tagword">
              {infoLinks[selected_link_id].data.tag_word}
            </span>
          )}
          <div className="feature-description" style={{ height: calcHeight() }}>
            <Dotdotdot clamp={`${calcHeight()}`} tagName={'p'}>
              {/*{long_content}*/}
              <HTMLView className={''} html={long_content} tagName={'p'} />
            </Dotdotdot>
            {show_overlay_button ? renderOverlayButton : null}
          </div>
        </div>
      </div>
      {showOverlay}
    </div>
  );
};
export default CultureLeadershipMobileView;
